module.exports = __webpack_public_path__ + "f56e2aa61b0ccb2f4a4e3d5df16818df.png";